import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import Leaflet and Routing Machine CSS
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import 'leaflet/dist/leaflet.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
